var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-add"},[_c('div',{staticClass:"add-title"},[_vm._v("临时用户详情")]),_c('base-form',{attrs:{"formType":"detail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }